import React from 'react'
import { Field } from 'formik'

const CheckboxItem = ({ mod, id, name, label, disabled }) => {
  return (
    <div className={`checkbox_label_wrap ${mod}`}>
      <Field
        className="checkbox_input"
        type="checkbox"
        id={id}
        name={name}
        disabled={!!disabled}
      />
      <label className={`checkbox_label ${mod}`} htmlFor={id}>
        {label}
      </label>
    </div>
  )
}

export default CheckboxItem
